import React from 'react';
import { Link } from 'gatsby';
import { FormattedMessage } from 'react-intl';
import { ArrowRight } from '@carbon/icons-react';

import bg from './bg.jpg';
import * as css from './Webinars.module.scss';

type WebinarDatum = {
    image?: string;

    title: string;
    description: string;

    length: number;
    level: string;
    url: string;
};
const data = new Array<WebinarDatum>(3).fill({
    title: 'Farm Proxy: Installation and Configuration',
    description:
        'Large scale miners face many challenges. A hashrate aggregation proxy is a key tool that miners can use to optimize their farms.',
    length: 13 * 60,
    level: 'Beginer',
    url: '/en/',
});

export function Webinars() {
    return (
        <section className={css.root}>
            <div className={css.header}>
                <FormattedMessage tagName="h1" defaultMessage="Featured Webinars" />
                <Link to="/en/" className={css.viewAll}>
                    <FormattedMessage tagName="span" defaultMessage="View All" />
                    &nbsp; &nbsp;
                    <ArrowRight size={16} />
                </Link>
            </div>
            <div
                className={css.grid}
                children={data.map((d, i) => {
                    return (
                        <Link to={d.url} key={i} className={css.cell}>
                            <div
                                aria-hidden
                                className={css.image}
                                style={{ backgroundImage: `url(${d.image || bg})` }}
                            />
                            <div className={css.content}>
                                <div className={css.title} children={d.title} />
                                <div className={css.description} children={d.description} />
                                <div className={css.footer}>
                                    {d.length}
                                    &nbsp;&middot;&nbsp;
                                    {d.level}
                                </div>
                            </div>
                        </Link>
                    );
                })}
            />
        </section>
    );
}
